/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type mutationsUpdateMerchantMutationVariables = {
    accountID: string;
};
export type mutationsUpdateMerchantMutationResponse = {
    readonly updateMerchantPayments: {
        readonly updateLink: string;
    };
};
export type mutationsUpdateMerchantMutation = {
    readonly response: mutationsUpdateMerchantMutationResponse;
    readonly variables: mutationsUpdateMerchantMutationVariables;
};



/*
mutation mutationsUpdateMerchantMutation(
  $accountID: ID!
) {
  updateMerchantPayments(input: {accountID: $accountID}) {
    updateLink
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "accountID",
            "variableName": "accountID"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "UpdateMerchantResponse",
    "kind": "LinkedField",
    "name": "updateMerchantPayments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updateLink",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsUpdateMerchantMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mutationsUpdateMerchantMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e05271bdf1e2b24ca45723b35abce21",
    "id": null,
    "metadata": {},
    "name": "mutationsUpdateMerchantMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsUpdateMerchantMutation(\n  $accountID: ID!\n) {\n  updateMerchantPayments(input: {accountID: $accountID}) {\n    updateLink\n  }\n}\n"
  }
};
})();
(node as any).hash = 'bbfd63769958abd0672e4df733f98771';
export default node;
